module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flexContainer fd-c full"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flexContainer uploader fd-c"
  }, [_c('h2', {
    staticClass: "uploader-title"
  }, [_vm._v(_vm._s(_vm.$t("import.action")))]), _vm._v(" "), (_vm.loading === false) ? _c('div', {
    staticClass: "uploader-form"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "action": _vm.actionUrl,
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t("import.type")) + ": ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("import.choose")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "module"
    }
  }, [_vm._v(_vm._s(_vm.$t("import.module")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "product"
    }
  }, [_vm._v(_vm._s(_vm.$t("import.product")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accessory"
    }
  }, [_vm._v(_vm._s(_vm.$t("import.accessory")))])]), _vm._v(" "), _c('div', {
    staticClass: "uploader-form-input mt10"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": _vm.uploadFieldName,
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": function($event) {
        _vm.onSubmit($event.target);
        _vm.fileCount = $event.target.files.length;
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loading === true) ? _c('div', {
    staticClass: "spinner spinner--overlay"
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 2500,
      "size": 60,
      "color": '#41b4e8'
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02462935","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/uploader.vue
// module id = 2978
// module chunks = 0